export const TIMEOUTS = {
  SSN_HIDE: 5000,
  DOB_HIDE: 5000,
  COST_CENTER_MESSAGE: 10000,
  GRID_ACTIVATION: 0
} as const;

export const GRID_DEFAULTS = {
  PAGE_SIZE: 25,
  DEFAULT_PAGE: 1,
  EMAIL_SORT: { col: 'email', sort: '1' }
} as const;

export const HTTP_STATUS = {
  SUCCESS: 200,
  ERROR: 'error'
} as const;

export const USER_STATUSES = {
  ACTIVE: 'Active',
  SUSPENDED: 'Suspended',
  USER_ACTION_REQUIRED: 'User Action Required'
} as const;

export const MODAL_SIZES = {
  SMALL: 'sm',
  MEDIUM: 'md',
  LARGE: 'lg',
  EXTRA_LARGE: 'xl'
} as const;

export const SORT_DIRECTIONS = {
  ASC: 'asc',
  DESC: 'desc',
  ASC_VALUE: '1',
  DESC_VALUE: '-1'
} as const;